<template>
  <q-dialog
    :ref="modalRef"
    v-cloak
    full-width
    position="bottom"
    class="--fullscreen-height__padded"
  >
    <DialogHeader header="Search Filters" header-icon="sym_r_tune" />

    <q-card
      class="bg-background-light"
      square
      style="position: relative; width: 100%; height: 100%"
    >
      <q-form
        @submit="filterSearchResults"
        @reset="resetFilters"
        class="auto__srp__filters-mobile"
      >
        <q-list separator class="bg-background-light">
          <q-expansion-item expand-separator label="Make & Model">
            <div
              v-if="
                !searchLoaded &&
                  searchFilterOptions.makeModelsNested.length == 0
              "
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-expansion-item
              v-for="makeOption in searchFilterOptions.makeModelsNested"
              :key="makeOption.value + '_makeSearchFilterOption'"
              :header-inset-level="0"
              dense
              dense-toggle
              expand-separator
            >
              <template v-slot:header>
                <q-item-section>
                  <q-item-label>{{ makeOption.label }}</q-item-label>
                </q-item-section>
                <q-item-section side>
                  <q-skeleton
                    v-if="
                      refreshingFilterOptions.length > 0 &&
                        refreshingFilterOptions != 'makeId'
                    "
                    type="text"
                    class="text-subtitle1"
                    animation="fade"
                    style="width: 28px"
                  />
                  <small v-else>{{ makeOption.count }}</small>
                </q-item-section>
              </template>

              <q-item
                :key="makeOption.value + '_all_modelSearchFilterOption'"
                :inset-level="0.1"
                v-ripple
                tag="label"
                dense
                :disable="
                  refreshingFilterOptions.length > 0 &&
                    refreshingFilterOptions != 'makeId'
                "
              >
                <q-item-section side>
                  <q-checkbox
                    dense
                    v-model="searchFilterModels.makeId"
                    :val="makeOption.value"
                    color="secondary"
                    @click="performSearchFilterOptionsRefresh('makeId')"
                    :disable="
                      refreshingFilterOptions.length > 0 &&
                        refreshingFilterOptions != 'makeId'
                    "
                  />
                </q-item-section>
                <q-item-section>
                  All Models
                </q-item-section>
                <q-item-section side>
                  <q-skeleton
                    v-if="
                      refreshingFilterOptions.length > 0 &&
                        refreshingFilterOptions != 'makeId'
                    "
                    type="text"
                    class="text-subtitle1"
                    animation="fade"
                    style="width: 28px"
                  />
                  <small v-else>{{ makeOption.count }}</small>
                </q-item-section>
              </q-item>

              <div
                v-for="modelOption in makeOption.modelOptions"
                :key="
                  makeOption.value +
                    '_' +
                    modelOption.value +
                    '_modelSearchFilterOption'
                "
              >
                <q-item
                  :inset-level="0.1"
                  v-ripple
                  tag="label"
                  dense
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'modelId'
                  "
                >
                  <q-item-section side>
                    <q-checkbox
                      dense
                      v-model="searchFilterModels.modelId"
                      :val="modelOption.value"
                      color="secondary"
                      @click="performSearchFilterOptionsRefresh('modelId')"
                      :disable="
                        refreshingFilterOptions.length > 0 &&
                          refreshingFilterOptions != 'modelId'
                      "
                    />
                  </q-item-section>
                  <q-item-section>
                    <span class="ellipsis full-width">{{
                      modelOption.label
                    }}</span>
                  </q-item-section>
                  <q-item-section side>
                    <q-skeleton
                      v-if="
                        refreshingFilterOptions.length > 0 &&
                          refreshingFilterOptions != 'modelId'
                      "
                      type="text"
                      class="text-subtitle1"
                      animation="fade"
                      style="width: 28px"
                    />
                    <small v-else>{{ modelOption.count }}</small>
                  </q-item-section>
                </q-item>
                <div
                  v-if="searchFilterModels.modelId.includes(modelOption.value)"
                >
                  <q-item
                    v-for="trimOption in searchFilterOptions.modelIdTrim[
                      modelOption.value
                    ]"
                    :key="
                      modelOption.value +
                        '_' +
                        trimOption.value +
                        '_modelTrimSearchFilterOption'
                    "
                    :inset-level="0.3"
                    v-ripple
                    tag="label"
                    dense
                    :disable="
                      refreshingFilterOptions.length > 0 &&
                        refreshingFilterOptions != 'trim'
                    "
                  >
                    <q-item-section side>
                      <q-checkbox
                        dense
                        v-model="searchFilterModels.trim"
                        :val="trimOption.value"
                        color="secondary"
                        :disable="
                          refreshingFilterOptions.length > 0 &&
                            refreshingFilterOptions != 'trim'
                        "
                        @click="performSearchFilterOptionsRefresh('trim')"
                      />
                    </q-item-section>
                    <q-item-section>
                      <span class="ellipsis full-width">{{
                        trimOption.label
                      }}</span>
                    </q-item-section>
                    <q-item-section side>
                      <q-skeleton
                        v-if="
                          refreshingFilterOptions.length > 0 &&
                            refreshingFilterOptions != 'trim'
                        "
                        type="text"
                        class="text-subtitle1"
                        animation="fade"
                        style="width: 28px"
                      />
                      <small v-else>{{ trimOption.count }}</small>
                    </q-item-section>
                  </q-item>
                </div>
              </div>
            </q-expansion-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Body Type">
            <div
              v-if="!searchLoaded && searchFilterOptions.bodyType.length == 0"
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.bodyType"
              :key="i + '_bodyTypeSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'bodyType'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.bodyType"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'bodyType'
                  "
                  @click="performSearchFilterOptionsRefresh('bodyType')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'bodyType'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Condition">
            <div
              v-if="!searchLoaded && searchFilterOptions.condition.length == 0"
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.condition"
              :key="i + '_conditionSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'condition'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.condition"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'condition'
                  "
                  @click="performSearchFilterOptionsRefresh('condition')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'condition'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Price">
            <RangeWithInputs
              v-model="searchFilterModels.price"
              input-label="Price"
              :min="searchFilterOptions.price.min"
              :max="searchFilterOptions.price.max"
              @change="performSearchFilterOptionsRefresh('price')"
              :step-size="1000"
              input-prefix="$"
              number-formatted-input
              prevent-min-max-overlap
            />
          </q-expansion-item>

          <q-expansion-item expand-separator label="Mileage">
            <RangeWithInputs
              v-model="searchFilterModels.mileage"
              input-label="Mileage"
              :min="searchFilterOptions.mileage.min"
              :max="searchFilterOptions.mileage.max"
              @change="performSearchFilterOptionsRefresh('mileage')"
              :step-size="1000"
              number-formatted-input
              prevent-min-max-overlap
            />
          </q-expansion-item>

          <q-expansion-item expand-separator label="Year">
            <RangeWithInputs
              v-model="searchFilterModels.year"
              input-label="Year"
              :min="searchFilterOptions.year.min"
              :max="searchFilterOptions.year.max"
              @change="performSearchFilterOptionsRefresh('year')"
              :step-size="1"
              strict-range
            />
          </q-expansion-item>

          <q-expansion-item expand-separator label="Features">
            <div
              v-if="
                (!searchLoaded || featuresFilterOptionsLoading) &&
                  searchFilterOptions.features.length == 0
              "
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.features"
              :key="i + '_featureSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'features'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels[option.key]"
                  :true-value="option.value"
                  :false-value="''"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'features'
                  "
                  @click="performSearchFilterOptionsRefresh('features')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    featuresFilterOptionsLoading ||
                      (refreshingFilterOptions.length > 0 &&
                        refreshingFilterOptions != 'features')
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Exterior Color">
            <div
              v-if="
                !searchLoaded && searchFilterOptions.exteriorColor.length == 0
              "
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.exteriorColor"
              :key="i + '_colorSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'exteriorColor'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.exteriorColor"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'exteriorColor'
                  "
                  @click="performSearchFilterOptionsRefresh('exteriorColor')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'exteriorColor'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
              <q-item-section side>
                <div
                  v-if="option.value === 'Brown'"
                  style="background: #DBC5A4; border-radius: 200px; width: 20px; height: 20px; position: relative"
                >
                  <div
                    style="position: absolute; top: 0; left: 0; width: 50%; height: 100%; background: #914915; border-top-left-radius: 200px; border-bottom-left-radius: 200px"
                  ></div>
                </div>
                <div
                  v-else
                  :style="{ background: option.color }"
                  style="border-radius: 200px; width: 20px; height: 20px"
                />
              </q-item-section>
            </q-item>
          </q-expansion-item>
          <q-expansion-item expand-separator label="Interior Color">
            <div
              v-if="
                !searchLoaded && searchFilterOptions.interiorColor.length == 0
              "
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.interiorColor"
              :key="i + '_interiorColorSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'interiorColor'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.interiorColor"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'interiorColor'
                  "
                  @click="performSearchFilterOptionsRefresh('interiorColor')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'interiorColor'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
              <q-item-section side>
                <div
                  v-if="option.value === 'Brown'"
                  style="background: #DBC5A4; border-radius: 200px; width: 20px; height: 20px; position: relative"
                >
                  <div
                    style="position: absolute; top: 0; left: 0; width: 50%; height: 100%; background: #914915; border-top-left-radius: 200px; border-bottom-left-radius: 200px"
                  ></div>
                </div>
                <div
                  v-else
                  :style="{ background: option.color }"
                  style="border-radius: 200px; width: 20px; height: 20px"
                />
              </q-item-section>
            </q-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Fuel Type">
            <div
              v-if="!searchLoaded && searchFilterOptions.fuelType.length == 0"
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.fuelType"
              :key="i + '_fuelTypeSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'fuelType'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.fuelType"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'fuelType'
                  "
                  @click="performSearchFilterOptionsRefresh('fuelType')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'fuelType'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>
          <q-expansion-item expand-separator label="Drivetrain">
            <div
              v-if="!searchLoaded && searchFilterOptions.drivetrain.length == 0"
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.drivetrain"
              :key="i + '_drivetrainSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'drivetrain'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.drivetrain"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'drivetrain'
                  "
                  @click="performSearchFilterOptionsRefresh('drivetrain')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'drivetrain'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>

          <q-expansion-item expand-separator label="Transmission">
            <div
              v-if="
                !searchLoaded && searchFilterOptions.transmission.length == 0
              "
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.transmission"
              :key="i + '_transmissionSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'transmission'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.transmission"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'transmission'
                  "
                  @click="performSearchFilterOptionsRefresh('transmission')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'transmission'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>
          <q-expansion-item expand-separator label="Engine Type">
            <div
              v-if="!searchLoaded && searchFilterOptions.engineType.length == 0"
              class="flex justify-center q-pa-md"
            >
              <q-spinner size="2rem" color="grey-7" />
            </div>
            <q-item
              v-for="(option, i) in searchFilterOptions.engineType"
              :key="i + '_engineTypeSearchFilterOption'"
              :inset-level="0"
              v-ripple
              tag="label"
              dense
              :disable="
                refreshingFilterOptions.length > 0 &&
                  refreshingFilterOptions != 'engineType'
              "
            >
              <q-item-section side>
                <q-checkbox
                  dense
                  v-model="searchFilterModels.engineType"
                  :val="option.value"
                  color="secondary"
                  :disable="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'engineType'
                  "
                  @click="performSearchFilterOptionsRefresh('engineType')"
                />
              </q-item-section>
              <q-item-section>
                {{ option.label }}
              </q-item-section>
              <q-item-section side>
                <q-skeleton
                  v-if="
                    refreshingFilterOptions.length > 0 &&
                      refreshingFilterOptions != 'engineType'
                  "
                  type="text"
                  class="text-subtitle1"
                  animation="fade"
                  style="width: 28px"
                />
                <small v-else>{{ option.count }}</small>
              </q-item-section>
            </q-item>
          </q-expansion-item>
        </q-list>
      </q-form>

      <q-card-section
        class="bg-background q-py-md --shadow__top"
        style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 3;"
      >
        <q-btn
          color="secondary"
          rounded
          label="Apply"
          class="full-width"
          :disable="!searchLoaded"
          :loading="refreshingFilterOptions.length > 0"
          @click="filterSearchResults"
        />
        <q-btn
          flat
          rounded
          text-color="text-light"
          label="Reset Filters"
          color="text-light"
          class="full-width q-mt-sm"
          no-caps
          @click="resetFilters"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import DialogHeader from "@/components/UI/DialogHeader.vue";
import RangeWithInputs from "@/components/UI/RangeWithInputs.vue";

export default {
  name: "FiltersDialog",
  components: { RangeWithInputs, DialogHeader },
  data() {
    return {
      modalRef: "filtersDialog",
      refreshingFilterOptions: "",
      searchFilterModels: JSON.parse(
        JSON.stringify(this.$store.state.search.filter.models)
      )
    };
  },
  computed: {
    searchFilterOptions() {
      return this.$store.state.search.filter.options;
    },
    searchFilterModelDefaults() {
      return this.$store.state.search.filter.modelDefaults;
    },
    searchLoaded() {
      return this.$store.state.search.loaded;
    },
    featuresFilterOptionsLoading() {
      return this.$store.state.search.featuresFilterOptionsLoading;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    show() {
      this.$refs[this.modalRef].show();
    },
    hide() {
      this.$refs[this.modalRef].hide();
    },
    filterSearchResults() {
      this.$store.state.search.filter.models = JSON.parse(
        JSON.stringify(this.searchFilterModels)
      );
      this.$store
        .dispatch("search/CHECK_FILTER_MODELS_UPDATED")
        .then(updated => {
          if (updated) {
            this.$store.commit("search/RESET_PAGINATION");
            // Apply filter.models to searchFilters
            this.$store.dispatch("search/APPLY_FILTER_MODELS");
            this.$store.commit("search/SET_LOADING");
          }
          this.hide();
        });
    },
    resetFilters() {
      this.$store.commit("search/RESET_PAGINATION");
      this.$store.commit("search/SET_SEARCH_FILTERS", []);
      this.$store.commit("search/SET_LOADING");
      this.hide();
    },
    performSearchFilterOptionsRefresh(currentFilterField) {
      this.refreshingFilterOptions = currentFilterField;

      let filters = [
        {
          mileage: {
            gte: this.searchFilterModels["mileage"].min,
            lte: this.searchFilterModels["mileage"].max
          }
        },
        {
          price: {
            gte: this.searchFilterModels["price"].min,
            lte: this.searchFilterModels["price"].max
          }
        },
        {
          year: {
            gte: this.searchFilterModels["year"].min,
            lte: this.searchFilterModels["year"].max
          }
        }
      ];

      let orFilters = [];
      let trimOrFilters = [];
      let orFilterKeys = ["make_id", "model_id", "trim"];
      Object.keys(this.searchFilterModels).forEach(filterModelKey => {
        if (["mileage", "price", "year", "trim"].includes(filterModelKey))
          return;

        let filterInArray = this.searchFilterModels[filterModelKey];

        if (filterInArray.length > 0) {
          let filterKey = this.convertCamelToSnake(filterModelKey);

          if (
            filterKey === "model_id" &&
            this.searchFilterModels.trim.length > 0
          ) {
            filterInArray.forEach(filterModelIdValue => {
              if (
                this.searchFilterModels.trim.find(trimValue =>
                  trimValue.includes(filterModelIdValue + "|")
                )
              ) {
                this.searchFilterModels.trim.forEach(filterTrimValue => {
                  let [trimModelId, trim] = filterTrimValue.split("|");
                  if (trimModelId == filterModelIdValue) {
                    trimOrFilters.push({
                      model_id: { equals: trimModelId },
                      trim: { equals: trim }
                    });
                  }
                });
              }
            });

            orFilters.push({ [filterKey]: { in: filterInArray } });
          } else if (
            filterKey === "make_id" &&
            this.searchFilterModels.trim.length > 0
          ) {
            orFilters.push({ [filterKey]: { in: filterInArray } });
            trimOrFilters.push({ [filterKey]: { in: filterInArray } });
          } else if (filterKey.includes("features.")) {
            filters.push({ [filterKey]: { equals: "1" } });
          } else {
            if (orFilterKeys.includes(filterKey)) {
              orFilters.push({ [filterKey]: { in: filterInArray } });
            } else {
              filters.push({ [filterKey]: { in: filterInArray } });
            }
          }
        }
      });

      if (orFilters.length > 0) {
        filters.push({ or: orFilters });
      }
      if (trimOrFilters.length > 0) {
        filters.push({ or: trimOrFilters });
      }

      this.$store
        .dispatch("search/POPULATE_FILTER_OPTIONS", {
          filterParams: filters,
          includeLocationParam: true
        })
        .finally(() => {
          this.refreshingFilterOptions = "";
        });

      this.$store
        .dispatch("search/POPULATE_FILTER_OPTIONS", {
          filterParams: filters,
          includeLocationParam: true,
          featuresOnly: true
        })
        .finally(() => {
          this.refreshingFilterOptions = "";
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auto__srp__filters-mobile {
  background: color(background, light);
  overflow-y: auto;
  max-height: calc(100% - 194px);

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
